import { initKabelwerk } from './kabelwerk.js';

// the global Kabelwerk object
const Kabelwerk = initKabelwerk();

export default Kabelwerk;
